// extracted by mini-css-extract-plugin
module.exports = {"header":"ArchiveModal_header__3Wetm","buttonYes":"ArchiveModal_buttonYes__2kkeg"};